/** @type {import('../types').ProgramConfig} */
export default {
  code: 'WMP',
  displayName: 'ISV Workload Migration Program',
  shortName: 'WMP',
  color: 'green',
  statusLabels: {
    approve: 'Approve',
    reject: 'Reject',
    escalate: 'Escalate',
  },
  sidebarItems: [],
  listColumns: [],

  feedback: {
    enabled: true,
    validations: [
      { key: 'partner_eligibility',
        label: '1. Partner Eligibility (ARR-to-ACV methodology lookup)',
        keywords: ['partner eligibility', 'partner_eligibility'] },
      { key: 'deal_tracker',
        label: '2. Deal Tracker (tranche sequencing, prior approvals)',
        keywords: ['deal tracker', 'deal_tracker'] },
      { key: 'fr_fields',
        label: '3. FR Fields (program, ACE stage, AWS account ID)',
        keywords: ['fr fields', 'fr_fields'] },
      { key: 'proof_of_deal',
        label: '4. Proof of Deal (signed PO / SOW / Sales Order / MP Order Form)',
        keywords: ['proof of deal', 'proof_of_deal'] },
      { key: 'tranche_amounts',
        label: '5. Tranche Amounts (credit cap tiering, ARR-to-ACV check)',
        keywords: ['tranche amounts', 'tranche_amounts'] },
    ],
    // Bulk PIF (WMP_PIF) runs a different SOP chain — one spreadsheet of many
    // opportunities, no tranche model, no per-FR proof-of-deal PDF. The agent
    // writes validation keys pif_fields / pif_spreadsheet / pif_funding /
    // pif_opportunity_stage (plus the shared partner_eligibility), so the
    // reviewer-feedback options and summary-card checks must reflect those,
    // not the Misc tools above. Keyed by wmp_sub_program; accessors fall back
    // to the Misc `validations` when no sub-program (or an unknown one) is passed.
    subPrograms: {
      WMP_PIF: {
        validations: [
          { key: 'partner_eligibility',
            label: '1. Partner Eligibility (ARR-to-ACV methodology lookup)',
            keywords: ['partner eligibility', 'partner_eligibility'] },
          { key: 'pif_fields',
            label: '2. FR Fields (program, budget year, ARR, account IDs, opportunity count)',
            keywords: ['pif fields', 'pif_fields', 'fr fields'] },
          { key: 'pif_spreadsheet',
            label: '3. Bulk Spreadsheet (opportunity list parsed and reconciled)',
            keywords: ['pif spreadsheet', 'pif_spreadsheet', 'spreadsheet'] },
          { key: 'pif_funding',
            label: '4. Funding Reconciliation (sheet funding sum vs credit ask, per-row caps)',
            keywords: ['pif funding', 'pif_funding', 'funding'] },
          { key: 'pif_opportunity_stage',
            label: '5. Opportunity Stage (all opportunities in Launched stage)',
            keywords: ['pif opportunity stage', 'pif_opportunity_stage', 'opportunity stage'] },
        ],
      },
    },
    decisionOptions: [
      { value: 'recommend_approval',  label: 'Recommend Approval' },
      { value: 'recommend_rejection', label: 'Recommend Rejection' },
      { value: 'needs_review',        label: 'Needs Review' },
    ],
  },
};
